import { mockUser } from '_mocks'
import { freeze } from 'utils/freeze/freeze'

import { GetProfileData } from './types'

export const getProfileData: GetProfileData = async () => {
  await freeze()
  return mockUser()
}
